"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LazyLoadingBlockStyled = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    height: auto;\n    width: auto;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var LazyLoadingBlockStyled = (0, _uiKit.styled)(_uiKit.LoadingBlock)(_templateObject(), _uiKit.LoadingBlockStyled);
exports.LazyLoadingBlockStyled = LazyLoadingBlockStyled;